<template>
  <div class="detail_back_home" @click="goBackHome" :style="{ left: position ? position.left - 50 + 'px' : null }">
    <img class="icon" src="@/assets/images/back-home-icon.png" alt="" />
  </div>
</template>
<script>
export default {
  props: {
    position: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      scrollTo: 0
    };
  },
  methods: {
    goBackHome() {
      this.$emit("goBackHome");
    }
  }
};
</script>
<style lang="less" scoped>
.detail_back_home {
  position: fixed;
  left: -100px;
  top: 135px;
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #000;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(50, 50, 50, 0.04);
  &:hover {
    background: #f5f5f5;
  }

  .icon {
    width: 32px;
    height: 32px;
  }
}
</style>
